import { auditUserIdModel } from "config/filterModels/auditUserIdModel";
import { dateFilterModel } from "config/filterModels/dateFilterModel";
import { FilterModel } from "model/Filter.model";

export const auditFilterConfig: FilterModel[] = [dateFilterModel, auditUserIdModel];
